<script lang="ts">
    class OffertaTrasporto {
        nodiInterscambio: string = '';
        stazioniFerroviare: string = '';
        fermateBus: string = '';
        pisteCiclabili: string = '';
        parcheggioEsternoPagamento: boolean = undefined;
        areaPedonaleZTL: boolean = undefined;
        carSharing: boolean = undefined;
        scooterSharing: boolean = undefined;
        bikeSharing: boolean = undefined;
        monopattiniSharing: boolean = undefined;
        parcheggioAziendale: boolean = undefined;

        constructor(init?: OffertaTrasporto) {
            Object.assign(this, init);
        }
    }

    export let data: OffertaTrasporto = new OffertaTrasporto();

    function isAnyFieldSet(): boolean {
            return (data?.nodiInterscambio !== '' ||
                    data?.stazioniFerroviare !== '' ||
                    data?.fermateBus !== '' ||
                    data?.pisteCiclabili !== '' ||
                    data?.parcheggioEsternoPagamento !== undefined ||
                    data?.areaPedonaleZTL !== undefined ||
                    data?.carSharing !== undefined ||
                    data?.scooterSharing !== undefined ||
                    data?.bikeSharing !== undefined ||
                    data?.monopattiniSharing !== undefined ||
                    data?.parcheggioAziendale !== undefined) && data !== null;
        }
</script>
<table class="w-full text-xs border border-black table-fixed">
    <thead>
        <tr>
            <th class="border border-black">Voce</th>
            <th class="border border-black">Valore</th>
        </tr>
    </thead>
    <tbody>
        <tr>
            <td class="text-center border border-black">Presenza e qualità dei nodi di interscambio</td>
            <td class:bg-blue-100={!isAnyFieldSet()} class="text-center border border-black">{data?.nodiInterscambio || '-'}</td>
        </tr>
        <tr>
            <td class="text-center border border-black">Presenza e qualità delle stazioni ferroviarie</td>
            <td class:bg-blue-100={!isAnyFieldSet()} class="text-center border border-black">{data?.stazioniFerroviare || '-'}</td>
        </tr>
        <tr>
            <td class="text-center border border-black">Presenza e qualità delle fermate bus/filobus/tram</td>
            <td class:bg-blue-100={!isAnyFieldSet()} class="text-center border border-black">{data?.fermateBus || '-'}</td>
        </tr>
        <tr>
            <td class="text-center border border-black">Presenza e qualità di piste ciclabili/ciclopedonali da e verso l'azienda</td>
            <td class:bg-blue-100={!isAnyFieldSet()} class="text-center border border-black">{data?.pisteCiclabili || '-'}</td>
        </tr>
        <tr>
            <td class="text-center border border-black">Tariffazione della sosta su strade esterne all'azienda</td>
            <td class:bg-blue-100={!isAnyFieldSet()} class="text-center border border-black">
                {data?.parcheggioEsternoPagamento !== undefined ? (data?.parcheggioEsternoPagamento ? 'Sì' : 'No') : '-'}
            </td>
        </tr>
        <tr>
            <td class="text-center border border-black">Area pedonale o ZTL</td>
            <td class:bg-blue-100={!isAnyFieldSet()} class="text-center border border-black">
                {data?.areaPedonaleZTL !== undefined ? (data?.areaPedonaleZTL ? 'Sì' : 'No') : '-'}
            </td>
        </tr>
        <tr>
            <td class="text-center border border-black">Esistenza di servizi di car sharing</td>
            <td class:bg-blue-100={!isAnyFieldSet()} class="text-center border border-black">
                {data?.carSharing !== undefined ? (data?.carSharing ? 'Sì' : 'No') : '-'}
            </td>
        </tr>
        <tr>
            <td class="text-center border border-black">Esistenza di servizi di scooter sharing</td>
            <td class:bg-blue-100={!isAnyFieldSet()} class="text-center border border-black">
                {data?.scooterSharing !== undefined ? (data?.scooterSharing ? 'Sì' : 'No') : '-'}
            </td>
        </tr>
        <tr>
            <td class="text-center border border-black">Esistenza di servizi di bike sharing</td>
            <td class:bg-blue-100={!isAnyFieldSet()} class="text-center border border-black">
                {data?.bikeSharing !== undefined ? (data?.bikeSharing ? 'Sì' : 'No') : '-'}
            </td>
        </tr>
        <tr>
            <td class="text-center border border-black">Esistenza di servizi di monopattini in sharing</td>
            <td class:bg-blue-100={!isAnyFieldSet()} class="text-center border border-black">
                {data?.monopattiniSharing !== undefined ? (data?.monopattiniSharing ? 'Sì' : 'No') : '-'}
            </td>
        </tr>
        <tr>
            <td class="text-center border border-black">Disponibilità di un parcheggio aziendale</td>
            <td class:bg-blue-100={!isAnyFieldSet()} class="text-center border border-black">
                {data?.parcheggioAziendale !== undefined ? (data?.parcheggioAziendale ? 'Sì' : 'No') : '-'}
            </td>
        </tr>
    </tbody>
</table>